import { useEffect, useState } from "react";

const CategoryModal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    // hasMultipleProducts: false,
    order: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        slug: initialData.slug || "",
        // hasMultipleProducts: initialData.hasMultipleProducts || false,
        order: initialData.order || "",
      });
    }
  }, [initialData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-xl p-6">
        <h2 className="text-xl font-semibold mb-4">
          {initialData ? "Update Category" : "Create Category"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            name="name"
            placeholder="Category Name"
            className="w-full border px-3 py-2 rounded"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            name="slug"
            placeholder="Slug"
            className="w-full border px-3 py-2 rounded"
            value={formData.slug}
            onChange={handleChange}
          />

          <input
            name="order"
            type="number"
            placeholder="Order"
            className="w-full border px-3 py-2 rounded"
            value={formData.order}
            onChange={handleChange}
          />

          {/* <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="hasMultipleProducts"
              checked={formData.hasMultipleProducts}
              onChange={handleChange}
            />
            Has Multiple Products
          </label> */}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded"
            >
              {initialData ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;
